import React from "react";

const RocketIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="rocket_icon"
      data-name="rocket"
      {...props}
      width={props.width || "25"}
      height={props.height || "24"}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3207 2.38C20.1981 2.12857 19.0512 2.00114 17.9007 2C16.8142 1.93101 15.7248 2.0775 14.6951 2.43103C13.6654 2.78456 12.7157 3.33816 11.9007 4.06C10.8274 5.13333 9.76405 6.20333 8.71072 7.27C7.50072 7.14 4.63071 7.07 2.71071 9.01C2.52446 9.19736 2.41992 9.45081 2.41992 9.715C2.41992 9.97918 2.52446 10.2326 2.71071 10.42L14.0107 21.74C14.1981 21.9262 14.4515 22.0308 14.7157 22.0308C14.9799 22.0308 15.2334 21.9262 15.4207 21.74C17.3707 19.74 17.3107 16.92 17.1907 15.74L20.4007 12.54C23.5907 9.35 22.1407 3.36 22.0807 3.11C22.0345 2.92963 21.9389 2.76574 21.8047 2.63677C21.6704 2.50779 21.5028 2.41887 21.3207 2.38ZM18.9607 11.13L15.4007 14.67C15.2854 14.7864 15.2005 14.9294 15.1534 15.0863C15.1063 15.2432 15.0985 15.4093 15.1307 15.57C15.3467 16.9078 15.1587 18.2796 14.5907 19.51L4.92071 9.82C6.17057 9.24477 7.56773 9.07012 8.92072 9.32C9.08079 9.34084 9.24353 9.32262 9.39503 9.2669C9.54654 9.21117 9.6823 9.1196 9.79072 9C9.79072 9 11.1907 7.55 13.3007 5.44C14.5981 4.39811 16.2408 3.88389 17.9007 4C18.6815 4.00387 19.4607 4.07075 20.2307 4.2C20.4707 5.63 20.8507 9.24 18.9607 11.13Z"
        fill={props.fill || "#4CAF50"}
      />
      <path
        d="M16.1309 10.3C17.2354 10.3 18.1309 9.40462 18.1309 8.30005C18.1309 7.19548 17.2354 6.30005 16.1309 6.30005C15.0263 6.30005 14.1309 7.19548 14.1309 8.30005C14.1309 9.40462 15.0263 10.3 16.1309 10.3Z"
        fill={props.fill || "#4CAF50"}
      />
      <path
        d="M5.40039 16C3.40039 17 3.40039 21 3.40039 21C5.25146 20.9472 7.02354 20.2384 8.40039 19L5.40039 16Z"
        fill={props.fill || "#4CAF50"}
      />
    </svg>
  );
};

export default RocketIcon;
